import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import MenuIcon from '@mui/icons-material/Menu';
import { AppBar, Box, Icon, IconButton, Toolbar, Tooltip } from '@mui/material';
import React from 'react';
import { CustomerAlertsNotificationsResolver, ServiceDeskLink, UserManualDownload } from 'shared/components';
import { useAuthState } from 'shared/stores';
interface HeaderProps {
    headerRef: React.RefObject<HTMLDivElement>;
    drawerToggleHandler: () => void;
}

export function Header({ headerRef, drawerToggleHandler }: HeaderProps) {
    const { instance } = useMsal();
    const authenticated = useIsAuthenticated();
    const authState = useAuthState();
    const account = instance.getActiveAccount();

    const logout = async () => {
        instance.logout({ idTokenHint: account?.idToken });
    };
    return (
        <AppBar position='static' ref={headerRef}>
            <Toolbar
                sx={{
                    display: 'flex',
                    justifyContent: 'flex-start',
                }}
            >
                <IconButton
                    size='large'
                    edge='start'
                    color='inherit'
                    aria-label='menu'
                    sx={{ mr: 2 }}
                    onClick={drawerToggleHandler}
                >
                    <MenuIcon />
                </IconButton>
                <Box
                    sx={{
                        flexGrow: '1',
                    }}
                />
                {authenticated && (
                    <Box
                        sx={{
                            width: 350,
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                        }}
                    >
                        <CustomerAlertsNotificationsResolver user={authState.user.get()} />
                        User: {authState.user.get()?.displayName}
                        <ServiceDeskLink />
                        <UserManualDownload />
                        <Tooltip title='Logout'>
                            <IconButton onClick={logout}>
                                <Icon sx={{ color: 'common.white' }}>logout</Icon>
                            </IconButton>
                        </Tooltip>
                    </Box>
                )}
            </Toolbar>
        </AppBar>
    );
}
